<div class="loader" *ngIf="loaderService.isLoading$ | async">
  <app-loader></app-loader>
</div>

<div class="content">
  <div class="content-header">
    <app-header></app-header>
    <app-global-subheader></app-global-subheader>
  </div>
  <div class="content-outlet">
    <app-notification></app-notification>
    <router-outlet></router-outlet>
  </div>
</div>
